import {
  BookOpenText,
  Boxes,
  Calculator,
  CalendarRange,
  ChartColumn,
  Factory,
  FolderOpen,
  HandCoins,
  LayoutDashboard,
  Package,
  Settings,
  ShoppingCart,
  Store,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  key: string;
  to: string;
  icon: LucideIcon;
  /** phase in which the module becomes active (brief §12); undefined = available */
  phase?: number;
}

/** Web IA — design "İlkeler ve Sözlük": 13 items (Evraklar joined them), collapsible to icons. */
export const NAV: NavItem[] = [
  { key: 'today', to: '/', icon: LayoutDashboard },
  { key: 'stock', to: '/stock', icon: Boxes },
  { key: 'items', to: '/items', icon: Package },
  { key: 'procurement', to: '/procurement', icon: ShoppingCart, phase: 3 },
  { key: 'production', to: '/production', icon: Factory, phase: 5 },
  { key: 'amazon', to: '/amazon', icon: Store, phase: 4 },
  { key: 'planning', to: '/planning', icon: CalendarRange, phase: 6 },
  { key: 'costing', to: '/costing', icon: Calculator, phase: 3 },
  { key: 'sales', to: '/sales', icon: HandCoins, phase: 7 },
  { key: 'accounting', to: '/accounting/contacts', icon: BookOpenText },
  { key: 'documents', to: '/documents', icon: FolderOpen },
  { key: 'reports', to: '/reports', icon: ChartColumn, phase: 8 },
  { key: 'settings', to: '/settings', icon: Settings },
];

export const ACCOUNTING_NAV = [
  { key: 'contacts', to: '/accounting/contacts' },
  { key: 'invoices', to: '/accounting/invoices' },
  { key: 'cash', to: '/accounting/cash' },
  { key: 'partners', to: '/accounting/partners' },
  { key: 'period', to: '/accounting/period' },
  { key: 'reconciliation', to: '', phase: 7 },
] as const;

/**
 * Stock sub-nav, rendered like the accounting one. The rows a later task brings
 * keep their place with no `to`, so the block does not change shape when the
 * label screens ship.
 */
export const STOCK_NAV = [
  { key: 'onHand', to: '/stock' },
  { key: 'movements', to: '/stock/movements' },
  { key: 'lots', to: '/stock/lots' },
  { key: 'counts', to: '/stock/counts' },
  { key: 'labels', to: '' },
] as const;

export const MODULE_PHASE: Record<string, number> = Object.fromEntries(NAV.filter((n) => n.phase).map((n) => [n.key, n.phase!]));
